import React from "react";
import styled from "styled-components";

export const ButtonContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;

    > * {
        margin: 0.2em;
    }

    @media only screen and (max-width: 500px) {
        display: flex;
        flex-direction: column;
    }
`;
